<template>
    <div class="section-block record-block">
        <div class="section-title">补材通知记录</div>
        <el-scrollbar class="timeline-scrollbar" v-loading="recordLoading">
            <el-timeline v-if="recordList.length">
                <el-timeline-item
                    v-for="(item, index) in recordList"
                    :key="item.id || index"
                    :timestamp="item.createTime"
                    placement="top"
                >
                    <template #dot>
                        <img src="@/assets/images/Investigation/timefille-icon.png" alt="" class="timeline-dot-img" />
                    </template>
                    <div class="timeline-card">
                        <div class="timeline-card-header">
                            <span class="timeline-card-title">{{ item.title }}</span>
                            <el-tag :type="item.status === '1' ? 'success' : 'warning'" size="small">
                                {{ item.status === '1' ? '已完成' : '待补证' }}
                            </el-tag>
                        </div>
                        <div class="timeline-card-desc">{{ item.remark }}</div>
                        <div class="timeline-card-actions">
                            <el-button type="primary" link size="small" @click="handleViewDetail(item)">查看详情</el-button>
                            <el-button type="warning" link size="small" @click="handleEdit(item)">编辑</el-button>
                            <el-button type="danger" link size="small" @click="handleDelete(item)">删除</el-button>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
            <div v-else class="record-empty">暂无补材通知记录</div>
        </el-scrollbar>

        <el-dialog :visible.sync="detailVisible" title="补材通知详情" width="520px" append-to-body>
            <el-descriptions v-if="currentRecord" :column="1" border>
                <el-descriptions-item label="通知时间">{{ currentRecord.createTime }}</el-descriptions-item>
                <el-descriptions-item label="通知类型与接收方">{{ currentRecord.title }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                    <el-tag :type="currentRecord.status === '1' ? 'success' : 'warning'" size="small">
                        {{ currentRecord.status === '1' ? '已完成' : '待补证' }}
                    </el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="补充说明">{{ currentRecord.remark || '-' }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>

        <el-dialog :visible.sync="editVisible" title="编辑补材通知" width="520px" append-to-body @close="resetEditForm">
            <el-form ref="editFormRef" :model="editForm" :rules="formRules" label-width="120px">
                <el-form-item label="通知类型" prop="noticeType">
                    <el-select v-model="editForm.noticeType" placeholder="请选择通知类型" clearable style="width: 100%;">
                        <el-option
                            v-for="item in noticeTypeOptions"
                            :key="item.dictValue"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="接收方" prop="receiver">
                    <el-select v-model="editForm.receiver" placeholder="请选择接收方" clearable style="width: 100%;">
                        <el-option
                            v-for="item in receiverOptions"
                            :key="item.dictValue"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="补材期限(天)" prop="deadlineDays">
                    <el-input
                        v-model.number="editForm.deadlineDays"
                        type="number"
                        placeholder="请输入天数"
                        style="width: 100%;"
                    />
                </el-form-item>
                <el-form-item label="补充说明" prop="remark">
                    <el-input
                        v-model="editForm.remark"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入补充说明"
                        resize="vertical"
                    />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="editVisible = false">取消</el-button>
                <el-button type="primary" :loading="editLoading" @click="handleEditSubmit">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { getListByDictType } from '@/api/sys/dictData'

export default {
    name: 'SupplementRecordTimeline',
    data() {
        return {
            recordLoading: false,
            recordList: [],
            detailVisible: false,
            editVisible: false,
            currentRecord: null,
            editForm: {
                id: '',
                noticeType: '',
                receiver: '',
                deadlineDays: 7,
                remark: ''
            },
            formRules: {
                noticeType: [{ required: true, message: '请选择通知类型', trigger: 'change' }],
                receiver: [{ required: true, message: '请选择接收方', trigger: 'change' }],
                deadlineDays: [
                    { required: true, message: '请输入补材期限', trigger: 'blur' },
                    { type: 'number', min: 1, max: 365, message: '请输入 1-365 之间的天数', trigger: 'blur' }
                ]
            },
            noticeTypeOptions: [],
            receiverOptions: [],
            editLoading: false
        }
    },
    created() {
        this.loadDictData()
        this.loadRecordList()
    },
    methods: {
        async loadDictData() {
            const dictTypes = [
                { key: 'noticeTypeOptions', type: 'industrial_injury_supplement_notice_type' },
                { key: 'receiverOptions', type: 'industrial_injury_supplement_receiver' }
            ]
            for (const { key, type } of dictTypes) {
                try {
                    const res = await getListByDictType(type)
                    if (res && res.code === 200 && res.data) {
                        this[key] = res.data
                    }
                } catch (e) {
                    console.warn(`字典 ${type} 加载失败`, e)
                }
            }
        },
        loadRecordList() {
            this.recordLoading = true
            setTimeout(() => {
                this.recordList = [
                    {
                        id: 1,
                        createTime: '2024-08-19 10:30:20',
                        title: '材料补正 - 用人单位',
                        remark: '请补充工伤认定申请表、劳动关系证明材料',
                        status: '1'
                    },
                    {
                        id: 2,
                        createTime: '2024-08-18 14:20:00',
                        title: '证据补充 - 双方',
                        remark: '请提供事发时的监控视频',
                        status: '0'
                    }
                ]
                this.recordLoading = false
            }, 300)
        },
        handleViewDetail(item) {
            this.currentRecord = item
            this.detailVisible = true
        },
        handleEdit(item) {
            this.currentRecord = item
            this.editForm = {
                id: item.id,
                noticeType: item.noticeType || '',
                receiver: item.receiver || '',
                deadlineDays: item.deadlineDays ?? 7,
                remark: item.remark || ''
            }
            this.editVisible = true
        },
        resetEditForm() {
            this.editForm = {
                id: '',
                noticeType: '',
                receiver: '',
                deadlineDays: 7,
                remark: ''
            }
            this.$refs.editFormRef?.resetFields()
        },
        handleEditSubmit() {
            this.$refs.editFormRef.validate((valid) => {
                if (!valid) return
                this.editLoading = true
                setTimeout(() => {
                    this.$message.success('保存成功')
                    this.editLoading = false
                    this.editVisible = false
                    this.loadRecordList()
                }, 400)
            })
        },
        handleDelete(item) {
            this.$confirm('确认删除该补材通知记录？', '提示', { type: 'warning' })
                .then(() => {
                    this.recordList = this.recordList.filter((r) => r.id !== item.id)
                    this.$message.success('删除成功')
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.section-block {
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 0;

    .section-title {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        padding-left: 11px;
        margin-bottom: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 12px;
            border-radius: 20px;
            background: var(--vt-c-blue);
        }
    }
}

.record-block {
    display: flex;
    flex-direction: column;
    height: 100%;

    .section-title {
        flex-shrink: 0;
    }
}

.timeline-scrollbar {
    flex: 1;
    min-height: 320px;
    //max-height: calc(100vh - 280px);

    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
}

:deep(.el-timeline) {
    padding-left: 8px;
}

.timeline-dot-img {
    display: block;
    width: 20px;
    height: 20px;
    object-fit: contain;
    position: absolute;
    top: 46%;
    right: 65%;
    transform: translate(65%, -25%);
}

.timeline-card {
    padding: 12px 0;
}

.timeline-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.timeline-card-title {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
}

.timeline-card-desc {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 10px;
}

.timeline-card-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.record-empty {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
}
</style>
